import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export {
  formatDate,
  formatDateOnly,
  formatCompactDate,
  formatShortDate,
  formatTimeOnly,
  formatDateTimeWithSeconds,
  isSameJakartaDay,
  formatRelativeTime,
  formatDuration,
  formatPrice,
} from '@test-prep/i18n';

const COURSE_ENGINE_URL =
  process.env.NEXT_PUBLIC_COURSE_ENGINE_URL || 'http://localhost:3505';

export function buildCourseEngineUrl(courseSlug: string, lessonId?: string | null): string {
  const url = new URL(COURSE_ENGINE_URL);
  url.searchParams.set('course', courseSlug);
  if (lessonId) url.searchParams.set('lesson', lessonId);
  return url.toString();
}
